module.exports = __webpack_public_path__ + "static/media/juxing.c947d225.png";